import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatSnackBar} from '@angular/material';

@Component({
  selector: 'app-modal-influencer-link',
  templateUrl: './modal-influencer-link.component.html',
  styleUrls: ['./modal-influencer-link.component.scss']
})
export class ModalInfluencerLinkComponent implements OnInit {

  copying = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public snackBar: MatSnackBar
  ) { }

  ngOnInit() {}

  copyToClipboardUrl() {
    this.copying = true;
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = this.data.influencer_link;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.openSnackBar('Copied to clipboard', 'Close');
    setTimeout( () => { this.copying = false; }, 700 );
  }

  openSnackBar(message, action) {
    this.snackBar.open(message, action, {
      duration: 2000,
      horizontalPosition: 'center',
      verticalPosition: 'top',
    });
  }

}
